import { render, staticRenderFns } from "./BaseGoodsAction.vue?vue&type=template&id=00b4d73a&scoped=true&"
import script from "./BaseGoodsAction.vue?vue&type=script&lang=js&"
export * from "./BaseGoodsAction.vue?vue&type=script&lang=js&"
import style0 from "./BaseGoodsAction.vue?vue&type=style&index=0&id=00b4d73a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b4d73a",
  null
  
)

export default component.exports